// extracted by mini-css-extract-plugin
export default {"icon":"OVmhhwgIAcBq5C94k6QtPA==","subtitle":"_7WsmwGe0mZvH2VML+MyBiA=="};